import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { ThemeProvider } from 'styled-components';

import App from './App';
import { store, persistor } from './redux/store';
import LocaleWrapper from './components/locale-wrapper/locale-wrapper.component';
import ScrollToTop from './components/scrollToTop/scroll-to-top.component';

// styles
import GlobalStyle from './styles/main';
import { theme } from './styles/theme/theme';

import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <Provider store={store}>
    <HashRouter>
      <PersistGate persistor={persistor}>
        <ThemeProvider theme={theme}>
          <GlobalStyle />
          <LocaleWrapper>
            <ScrollToTop />
            <App />
          </LocaleWrapper>
        </ThemeProvider>
      </PersistGate>
    </HashRouter>
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
